import { render, staticRenderFns } from "./TemplateDeleteModal.vue?vue&type=template&id=77089693&"
import script from "./TemplateDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./TemplateDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports